import React, { Component } from 'react';
import { _addNotification, _addNotificationError, getSchoolGrades, groupBy, showFile } from '../../../server/util';
import { get, putWithHeadersResponse } from '../../../server/actions';

class ESEAForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: this.props.data,
            otherChailds: []

        }
    }
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.data) {
            this.setState({ data: nextProps.data });
        }
    }
    onCancelApplication = () => {
        this.props.getESEAFormList();

    }
    submitApplication = () => {
        const { data, otherChailds } = this.state;
        const url = `/eseaForms/${data.id}?access_token=`;
        const reqBody = { ...data };
        let headers = {
            'Content-Type': 'application/json'
        };
        otherChailds.map(ch => {
            reqBody.students.push({
                "firstName": ch.name,
                "lastName": '',
                "grade": ch.grade,
                "schoolName": ch.schoolName
            });
        })

        putWithHeadersResponse(url, JSON.stringify(reqBody), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this.props);
            setTimeout(() =>
                this.props.getESEAFormList(), 1000);

        }).catch(error => {
            _addNotificationError('Unable to update request ! Try Again.', this.props);
        });

    }
    onPrintApp = () => {
        const { data } = this.state;
        const url = `/eseaForms/print/${data.id}?access_token=`;
        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            this.setState({ loading: false })
            let filename = `esea_form_${data.id}`;
            showFile(blob, filename);
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this.props)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )

    }
    render() {
        const { data, otherChailds } = this.state;
        return (
            <div>
                <div className="panel panel-primary">
                    <div className="panel-body">
                        <div className='row'>
                            <div className='col-md-offset-1 col-md-10'>
                                <div className='row'>
                                    <div className='col-md-6 sectionTitle'>
                                        <h2 >ESEA (Title I) Income Eligibility</h2>
                                    </div>
                                    <div className='col-md-6 text-right'>
                                        <button type="button" className='btn btn-sm btn-primary' onClick={(e) => {
                                            this.onPrintApp(e)
                                        }}>Print</button>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <p>
                                            The Arizona Department of Education provides the following FY 2024 Income Guidelines for determining eligibility information for federal
                                            funding associated with programs funded under the Elementary and Secondary Education Act (ESEA).
                                        </p>
                                        <p>
                                            Is your family at or below the current income guidelines based on the attached ESEA (Title I) Income Eligibility Guidelines schedule?
                                        </p>
                                        <p>
                                            <ul style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <li><input type="checkbox" className='chbox' checked={data.indicator == 'Indicator 1'} value='Indicator 1' onChange={(e) => {
                                                    if (e.target.checked) {
                                                        data.indicator = e.target.value;
                                                        this.setState({ data });
                                                    }
                                                }} /> Indicator 1</li>
                                                <li><input type="checkbox" className='chbox' checked={data.indicator == 'Indicator 2'} value='Indicator 2' onChange={(e) => {
                                                    if (e.target.checked) {
                                                        data.indicator = e.target.value;
                                                        this.setState({ data });
                                                    }
                                                }} /> Indicator 2</li>
                                                <li><input type="checkbox" className='chbox' checked={data.indicator == 'No'} value='No' onChange={(e) => {
                                                    if (e.target.checked) {
                                                        data.indicator = e.target.value;
                                                        this.setState({ data });
                                                    }
                                                }} /> No</li>
                                            </ul>
                                        </p>
                                        <p>
                                            Definition of Income: all items such as wages and salaries before any deductions, and other income, such as self employment, welfare, social
                                            security, retirement benefits unemployment compensation, worker's compensation, Aid for Dependent Children, alimony, child support,
                                            pensions, insurance or annuity payments, etc.
                                        </p>
                                        <p>If your family qualifies, please complete the following information for each child:</p>
                                        <p>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '50px' }}>S.No</th>
                                                        <th>Child's Name</th>
                                                        <th>Name of School</th>
                                                        <th>Grade</th>
                                                        <th style={{ width: '50px' }}>
                                                            <button className='btn btn-sm btn-success' style={{ margin: '0px' }} onClick={(e) => {
                                                                const _otherChailds = [...this.state.otherChailds];
                                                                _otherChailds.push({});
                                                                this.setState({ otherChailds: _otherChailds });
                                                            }} >
                                                                <i className='fa fa-plus'></i>
                                                            </button>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        (data.students || []).map((stud, i) => {
                                                            let label = '';
                                                            if (stud.studentRecId) {
                                                                const gradeGroup = groupBy(getSchoolGrades(0), 'value');
                                                                label = ((gradeGroup[stud.grade] || [])[0] || {}).label;
                                                            } else {
                                                                label = stud.grade;
                                                            }

                                                            return (<tr>
                                                                <td>{i + 1}.</td>
                                                                <td>{stud.firstName + ' ' + stud.lastName}</td>
                                                                <td>{stud.schoolName}</td>
                                                                <td>{label}</td>
                                                                <td></td>
                                                            </tr>)
                                                        })

                                                    }
                                                    {
                                                        (otherChailds || []).map((child, j) => {
                                                            return (<tr>
                                                                <td>{(data.students.length) + j + 1}.</td>
                                                                <td><input type='text' className='form-control' name="name" value={child.name || ''} onChange={(e) => {
                                                                    const _otherChailds = [...this.state.otherChailds];
                                                                    _otherChailds[j].name = e.target.value;
                                                                    this.setState({ otherChailds: _otherChailds });
                                                                }} /></td>
                                                                <td><input type='text' className='form-control' name="name" value={child.schoolName} onChange={(e) => {
                                                                    const _otherChailds = [...this.state.otherChailds];
                                                                    _otherChailds[j].schoolName = e.target.value;
                                                                    this.setState({ otherChailds: _otherChailds });
                                                                }} /></td>
                                                                <td><input type='text' className='form-control' name="name" value={child.grade} onChange={(e) => {
                                                                    const _otherChailds = [...this.state.otherChailds];
                                                                    _otherChailds[j].grade = e.target.value;
                                                                    this.setState({ otherChailds: _otherChailds });
                                                                }} /></td>
                                                                <td>
                                                                    <button className='btn btn-sm btn-danger' style={{ margin: '0px' }} onClick={(e) => {
                                                                        const _otherChailds = [...this.state.otherChailds];
                                                                        _otherChailds.splice(j, 1);
                                                                        this.setState({ otherChailds: _otherChailds });
                                                                    }} >
                                                                        <i className='fa fa-trash'></i>
                                                                    </button>
                                                                </td>
                                                            </tr>)
                                                        })
                                                    }

                                                </tbody>
                                            </table>
                                        </p>
                                        <p>
                                            I hereby certify that all the above information is true and correct.
                                        </p>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="parentSignature" className="col-md-2 col-form-label">Parent/Guardian :</label>
                                        <div className="col-md-4">
                                            <label>{data.parentSign}</label>
                                        </div>
                                        <label htmlFor="date" className="col-md-1 col-md-offset-3 col-form-label">Date:</label>
                                        <div className="col-md-2">
                                            <label>{data.date}</label>
                                        </div>
                                    </div>
                                    <div className='form-group row'>
                                        <div className='col-md-12'>
                                            <p>These survey forms should be retained by the school or LEA and kept on file for a period of 5 years.</p>
                                        </div>
                                    </div>
                                    <div className='form-group row'>
                                        <div className='col-md-12 text-right'>
                                            <button type="button" className='btn btn-sm btn-danger' onClick={(e) => {
                                                this.onCancelApplication(e)
                                            }}>Cancel</button>
                                            <button type="button" className='btn btn-sm btn-primary' onClick={(e) => {
                                                this.submitApplication(e)
                                            }}>Save</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default ESEAForm;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/EseaForm/ESEAForm.js